import script from "./ModalControls.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalControls.vue?vue&type=script&setup=true&lang=js"

import "./ModalControls.vue?vue&type=style&index=0&id=3b08b189&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b08b189"]])

export default __exports__